import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { OrderedMap } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'
import Moment from 'moment'
import Modal from 'react-modal'

import { createLogEntryFromToday } from '_modules/log/actions'
import { deleteTodayItem, createTodayItem, updateTodayItemDate } from '_modules/today-items/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { getTomorrowItems, createTomorrowItem } from '_modules/tomorrow-items/actions'
import { getReconcileItems, checkReconcileItem } from '_modules/reconcile/actions'
import { objectToArray } from '_utils/helperFunction'
import { createGoogleCalendarURL, createICalendarEvent } from '_utils/addToCalendar'
import { sortByOrder } from '_utils/sort'

import CalendarModal from './calendar-modal'
import EventFormModal from './event-form-modal'
import Card from './card'
import styles from './styles.css'

const mapStateToProps = ({ reconcile, tomorrowItems, todayItems, settings, user }) => ({
  reconcile,
  tomorrowItems,
  todayItems,
  settings,
  user,
})

const mapDispatchToProps = {
  getReconcileItems,
  getTomorrowItems,
  createTomorrowItem,
  updateLastActivityAt,
  deleteTodayItem,
  checkReconcileItem,
  createTodayItem,
  updateTodayItemDate,
  createLogEntryFromToday,
}

class Reconcile extends PureComponent {
  static propTypes = {
    reconcile: ImmutableProptypes.orderedMap,
    tomorrowItems: ImmutableProptypes.map,
    todayItems: ImmutableProptypes.orderedMap,
    settings: ImmutableProptypes.map,
    user: ImmutableProptypes.map,
    getReconcileItems: PropTypes.func.isRequired,
    getTomorrowItems: PropTypes.func.isRequired,
    createTomorrowItem: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    deleteTodayItem: PropTypes.func.isRequired,
    checkReconcileItem: PropTypes.func.isRequired,
    createTodayItem: PropTypes.func.isRequired,
    updateTodayItemDate: PropTypes.func.isRequired,
    createLogEntryFromToday: PropTypes.func.isRequired,
  }

  static defaultProps = {
    reconcile: new OrderedMap(),
    tomorrowItems: new Map(),
    todayItems: new OrderedMap(),
    settings: new Map(),
    user: new Map(),
  }

  state = {
    reconcileCards: [],
    isModalOpen: false,
    isCalendarModal: false,
    isEventFormModal: false,
  }

  componentWillMount() {
    this.props.getReconcileItems()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user.get('lastActivityAt') !== nextProps.user.get('lastActivityAt')) {
      this.props.getReconcileItems()
    }
    if (nextProps.reconcile !== this.props.reconcile) {
      const reconcileCards = this.formatCards(objectToArray(nextProps.reconcile.toJS()))

      this.setState({ reconcileCards })
    }
  }

  formatCards = arr =>
    arr.reduce((acc, ele) => {
      const startedAt = new Date(ele.startedAt).toDateString()
      // check for date in array, if does not exist, create one
      const foundDateIndex = Object.keys(acc).findIndex(
        key => new Date(key).toDateString() === startedAt
      )
      // create new Date section
      if (foundDateIndex === -1) {
        acc[startedAt] = [ele]
        return acc
      }
      // add to date section
      acc[startedAt].push(ele)
      return acc
    }, [])

  checkReconcileCard = (logId, todayItemId, startedAt, name, status) => {
    // if kept at today,
    // if today item exists and no log already, perform a create log from today
    // if today item and log exists, update log
    // if no today item and log exists, updated log

    // if not kept at today,
    // if today item exists and no log, delete today item / create log
    // if today item and log item, update log, delete today item
    // if no today item and log exists, update log

    const keptAtToday = Moment(startedAt).format('DDMMYY') === Moment().format('DDMMYY')
    if (keptAtToday) {
      if (todayItemId && !logId) {
        const payload = {
          name,
          type: 3,
          time: new Date(),
          status,
          logEntry: logId,
          todayItem: todayItemId,
        }
        this.props.createLogEntryFromToday(payload)
      }
      if (logId) {
        this.props.checkReconcileItem({ logId })
      }
    } else {
      if (todayItemId && !logId) {
        const payload2 = {
          name,
          type: 3,
          time: startedAt,
          status,
          logEntry: logId,
          todayItem: todayItemId,
        }
        this.props.createLogEntryFromToday(payload2).then(() => {
          this.markLogAsCompleteandDeleteToday(logId, todayItemId)
        })
      } else {
        this.markLogAsCompleteandDeleteToday(logId, todayItemId)
      }
    }
    this.props.getReconcileItems()
  }

  deleteCard = (logId, todayItemId) => {
    this.markLogAsCompleteandDeleteToday(logId, todayItemId)
  }

  createTomorrowItemCard = (name, sectionId, todayItemId, logId) => {
    const { tomorrowItems } = this.props
    // find last order in tomorrowItems
    const order = tomorrowItems.reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
      section: sectionId,
    }

    this.props.createTomorrowItem(payload)
    this.props.getTomorrowItems()

    this.markLogAsCompleteandDeleteToday(logId, todayItemId)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  playCard = (name, logId, todayItemId) => {
    const { settings } = this.props
    if (logId) this.props.checkReconcileItem({ logId })

    const flexibleTime = settings.get('flexibleTime')

    browserHistory.push({
      pathname: '/',
      state: {
        name,
        action: 'start',
        logEntry: logId || null,
        flexibleTime,
      },
    })
  }

  markLogAsCompleteandDeleteToday = (logId, todayItemId) => {
    if (logId) this.props.checkReconcileItem({ logId })
    if (todayItemId) this.props.deleteTodayItem(todayItemId)
    this.props.getReconcileItems()
  }

  createTodayItemCard = (logId, todayItemId, name) => {
    const { todayItems } = this.props
    // if log id, check off logId,
    // if today id, move kept at to today
    // if log id but no today id, create new today
    if (logId) this.props.checkReconcileItem({ logId })
    if (todayItemId) {
      this.props.updateTodayItemDate(todayItemId).then(() => {
        this.props.getReconcileItems()
      })
    } else {
      const order = todayItems.reduce((prevVal, card) => {
        if (card.order > prevVal) {
          return card.order
        }
        return prevVal
      }, 0)

      const payload = {
        name,
        order: order + 1,
      }

      this.props.createTodayItem(payload).then(() => {
        this.props.getReconcileItems()
      })
    }
  }

  createCalendarCard = payload => {
    const { name } = payload
    this.setState({
      isCalendarModal: true,
      isModalOpen: true,
      modalName: name,
    })
  }

  handleCalendarClick = type => {
    const { modalName: name, modalDatetime: datetime, modalDuration: duration } = this.state
    switch (type) {
      case 'gcal': {
        const url = createGoogleCalendarURL({ name })
        window.open(url, '_blank')
        this.resetState()
        break
      }
      case 'apple':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().add(1, 'hours'),
        })
        break
      case 'outlook':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().add(1, 'hours'),
        })
        break
      case 'ics':
        createICalendarEvent({ name, datetime, duration })
        this.resetState()
        break
      default:
    }
  }

  onNameChange = e => this.setState({ modalName: e.target.value })

  onDatetimeChange = modalDatetime => this.setState({ modalDatetime })

  onDurationChange = e => this.setState({ modalDuration: e.target.value })

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirmModal(event)
    }
  }

  onConfirmModal = () => this.handleCalendarClick('ics')

  resetState = () => {
    this.setState({
      isModalOpen: false,
      isCalendarModal: false,
      isEventFormModal: false,
    })
  }

  renderCard = card => {
    return (
      <Card
        key={card.startedAt}
        startedAt={card.startedAt}
        name={card.name}
        status={card.status}
        logId={card.logId}
        todayItemId={card.todayItemId}
        createTomorrowItemCard={this.createTomorrowItemCard}
        checkReconcileCard={this.checkReconcileCard}
        createCalendarCard={this.createCalendarCard}
        createTodayItemCard={this.createTodayItemCard}
        deleteCard={this.deleteCard}
        playCard={this.playCard}
      />
    )
  }

  renderSections = date => {
    const currentDateCards = this.state.reconcileCards[date]
    const todayItems = currentDateCards.filter(c => c.todayItemId).sort(sortByOrder)
    const logItems = currentDateCards.filter(c => c.logId && !c.todayItemId)
    return (
      <div key={date} className={classnames(styles.listContainer)}>
        <div className={classnames(styles.date)}>{date}</div>
        {todayItems.map(this.renderCard)}
        {logItems.map(this.renderCard)}
      </div>
    )
  }

  render() {
    const {
      reconcileCards,
      isModalOpen,
      isCalendarModal,
      isEventFormModal,
      modalName,
      modalDatetime,
      modalDuration,
    } = this.state
    const calendars = [
      {
        name: 'Google Calendar',
        function: () => this.handleCalendarClick('gcal'),
        icon: 'fa fa-google',
      },
      {
        name: 'Outlook Calendar',
        function: () => this.handleCalendarClick('outlook'),
        icon: 'fa fa-windows',
      },
      {
        name: 'Apple Calendar',
        function: () => this.handleCalendarClick('apple'),
        icon: 'fa fa-apple',
      },
    ]

    return (
      <div ref={div => (this.divRef = div)} className={classnames(styles.main)}>
        <button
          style={{ position: 'absolute', top: 30, right: 25 }}
          className={classnames(styles.backButton)}
          type="submit"
          onClick={() => browserHistory.goBack()}
        >
          <i className="fa fa-times" />
        </button>
        <div style={{ color: 'white', fontSize: 20 }}>Reconcile</div>
        <div className={classnames(styles.content)}>
          {Object.keys(reconcileCards).map(this.renderSections)}
        </div>
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          onRequestClose={this.resetState}
          shouldCloseOnOverlayClick
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          {isCalendarModal && <CalendarModal calendars={calendars} />}
          {isEventFormModal && (
            <EventFormModal
              nameValue={modalName}
              nameOnChange={this.onNameChange}
              dateValue={modalDatetime}
              dateOnChange={this.onDatetimeChange}
              durationValue={modalDuration}
              durationOnChange={this.onDurationChange}
              button1Name="SAVE"
              button2Name="CANCEL"
              button1Function={this.onConfirmModal}
              button2Function={this.resetState}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reconcile)



// WEBPACK FOOTER //
// ./src/views/reconcile/index.js